import { MESSAGE_STATUSES } from '../models/messaging-message';
import { array } from '@ember/helper';
import { decodeText } from '../utils/messaging/format-text';
import { formatDate } from '../utils/messaging/format-date';
import { service } from '@ember/service';
import Avatar from './avatar.gjs';
import Component from '@glimmer/component';
import Message from './conversation-message/message.gjs';
import MessageSubtext from './conversation-message/message-subtext.gjs';
import RemovedMessage from './conversation-message/removed-message.gjs';
import styles from './conversation-message.module.scss';

const CONVERSATION_TRUNCATED_MESSAGE = 'CONVERSATION_TRUNCATED';

export default class ConversationMessage extends Component {
  @service messaging;
  @service intl;

  get parsedSystemMessage() {
    let { text, createdAt } = this.args.message;

    if (text !== CONVERSATION_TRUNCATED_MESSAGE) {
      return decodeText(
        text.replace(
          'on %created_at%',
          `at ${formatDate(new Date(createdAt))}`.replaceAll(' ', '&nbsp;')
        )
      );
    }

    let footer = this.messaging.currentProfile.isSuperUser
      ? this.intl.t('emc.truncated_system_message.footer')
      : '';

    return this.intl.t('emc.truncated_system_message.text', {
      date: formatDate(new Date(createdAt)),
      footer,
    });
  }

  shouldShowMessageSubtext = message => {
    if (message.deletedAt) {
      return false;
    }

    const showReadIndicator =
      message.id === this.args.conversation.lastReadOwnMessage?.id &&
      Object.keys(this.args.conversation.counterpartReadAt).length > 0;
    const showDeliveredIndicator =
      message.status === MESSAGE_STATUSES.DELIVERED &&
      message.id === this.args.conversation.mostRecentOwnMessage?.id;

    return (
      showReadIndicator ||
      message.status === MESSAGE_STATUSES.FAILED ||
      message.status === MESSAGE_STATUSES.SENDING ||
      showDeliveredIndicator
    );
  };

  <template>
    <div
      class="{{styles.component}}
        conversation-message
        {{if @message.isOwn 'own'}}
        {{if @message.isSystem 'system'}}"
      data-test-conversation-page-message
    >
      {{#if @message.isSystem}}
        <span class="message-text" data-test-system-message>{{this.parsedSystemMessage}}</span>
      {{else}}
        <div class="message-wrapper">
          {{#unless @message.isOwn}}
            <Avatar @users={{array @message.user}} />
          {{/unless}}

          {{#if @message.deletedAt}}
            <RemovedMessage @message={{@message}} />
          {{else}}
            <Message @message={{@message}} />
          {{/if}}
        </div>

        {{#if (this.shouldShowMessageSubtext @message)}}
          <MessageSubtext
            @conversation={{@conversation}}
            @message={{@message}}
            @onResend={{@onResend}}
          />
        {{/if}}
      {{/if}}
    </div>
  </template>
}
